import { useState } from 'react';
import { Link } from 'react-router-dom';
import { t, getLocale, setLocale } from '../i18n';

export default function RequestAccessPage() {
  const [form, setForm] = useState({ name: '', email: '', company: '', relation: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/request-access', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setSuccess(data.message);
      setForm({ name: '', email: '', company: '', relation: '' });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Nav */}
      <nav style={{ padding: '0 40px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid var(--border)', background: 'white', flexShrink: 0 }}>
        <Link to="/" style={{ fontFamily: 'Playfair Display', fontSize: 22, fontWeight: 700, color: 'var(--match-a)', textDecoration: 'none' }}>
          {t('brand')}
        </Link>
        <button
          className="btn btn-ghost"
          style={{ fontSize: 14 }}
          onClick={() => setLocale(getLocale() === 'en' ? 'ja' : 'en')}
        >
          {getLocale() === 'en' ? '日本語' : 'EN'}
        </button>
      </nav>

      <div style={{
        flex: 1,
        display: 'flex',
        background: 'linear-gradient(135deg, #f0fdf4 0%, #fafdf5 60%, #dcfce7 100%)'
      }}>
      {/* Left panel */}
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center',
        padding: '60px', maxWidth: 480,
        background: 'linear-gradient(160deg, #3d5429 0%, #5a7a3a 100%)',
        color: 'white'
      }} className="auth-panel">
        <Link to="/" style={{ fontSize: 56, marginBottom: 16, display: 'block', textDecoration: 'none' }}>🍵</Link>
        <h1 style={{ fontSize: 40, fontFamily: 'Playfair Display', fontWeight: 700, marginBottom: 16, lineHeight: 1.2 }}>
          {t('authTagline')}
        </h1>
        <p style={{ fontSize: 18, opacity: 0.85, lineHeight: 1.7 }} dangerouslySetInnerHTML={{ __html: t('requestHeroSubtitle') }} />
      </div>

      {/* Right panel */}
      <div className="auth-form-panel" style={{
        flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 40
      }}>
        <div className="card auth-form-card" style={{ width: '100%', maxWidth: 420, padding: 40 }}>
          <h2 style={{ fontSize: 26, marginBottom: 8 }}>{t('requestAccessTitle')}</h2>
          <p style={{ color: 'var(--text-muted)', marginBottom: 28, fontSize: 15 }}>
            {t('requestAccessSubtitle')}
          </p>

          {error && (
            <div style={{
              background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca',
              borderRadius: 8, padding: '10px 14px', fontSize: 14, marginBottom: 20
            }}>{error}</div>
          )}

          {success ? (
            <div style={{
              background: '#f0fdf4', color: '#166534', border: '1px solid #bbf7d0',
              borderRadius: 8, padding: '16px', fontSize: 15, marginBottom: 20, lineHeight: 1.6
            }}>
              {success}
            </div>
          ) : (
            <form onSubmit={handle} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>
                  {t('requestAccessName')}
                </label>
                <input
                  className="input"
                  placeholder={t('requestAccessName')}
                  value={form.name}
                  onChange={e => setForm({ ...form, name: e.target.value })}
                  required
                />
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>
                  {t('email')}
                </label>
                <input
                  className="input"
                  type="email"
                  placeholder={t('email')}
                  value={form.email}
                  onChange={e => setForm({ ...form, email: e.target.value })}
                  required
                />
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>
                  {t('requestAccessCompany')}
                </label>
                <input
                  className="input"
                  placeholder={t('requestAccessCompany')}
                  value={form.company}
                  onChange={e => setForm({ ...form, company: e.target.value })}
                  required
                />
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>
                  {t('requestAccessRelation')}
                </label>
                <input
                  className="input"
                  placeholder={t('requestAccessRelationPlaceholder')}
                  value={form.relation}
                  onChange={e => setForm({ ...form, relation: e.target.value })}
                  required
                />
              </div>
              <button
                type="submit"
                className="btn btn-primary"
                style={{ marginTop: 8, justifyContent: 'center', padding: '12px' }}
                disabled={loading}
              >
                {loading ? '...' : t('requestAccessBtn')}
              </button>
            </form>
          )}

          <p style={{ marginTop: 24, textAlign: 'center', color: 'var(--text-muted)', fontSize: 14 }}>
            {t('alreadyHaveAccount')}{' '}
            <Link to="/login" style={{ color: 'var(--match-a)', fontWeight: 600 }}>{t('signIn')}</Link>
          </p>
        </div>
      </div>
      </div>
    </div>
  );
}
